

<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>
<!-- cart -->
<div class="cart-session" *ngIf="condition">
  <div class="cart_icons">
    <i class="fa fa-shopping-cart cart_fa" aria-hidden="true"></i> <span style="margin-left:5px;font-size: 1.2rem;font-weight: 600;" >{{cart_count}}</span>

  </div>
  <div class="" style="clear: both;"></div>
  <div class="cart-details">
    <div class="row">
      <div class="col-6">
        <h4>Shopping Cart</h4>
      </div>
      <div class="col-6">
        <h5 class="click_carts" (click)=removeall()>Remove all</h5>
      </div>

    </div>
    <div class="cart_item_list">
      <ng-template ngFor let-cartitems [ngForOf]="cartdatas" >
        <form #formshopcart="ngForm">
    <div class="py-3 cartelemet">
      <div class="cart_heading">
        <p>{{cartitems.cartname}} </p>
       
        <!-- <input type="hidden" name="shophead" [ngModel]="items.shop_head" > -->
      </div>
      <input type="hidden" name="shopids" [ngModel]="cartitems.cartid" > 
      <div class="cart_quanty">
        <input type="text" name="quanty" class="cart_qunty"  [ngModel]=cartitems.quantity (change)="updatecart(formshopcart.value)" > X 1
      </div>
       <div class="cart_remove">
         <p>{{cartitems.total_cartprice}} $ </p>
        <i (click)=removeCart(cartitems.cartid) class=" fa fa-trash" aria-hidden="true"></i>
      </div>
    </div>
  </form>
    </ng-template>

  </div>
  <div class="btns-cartbox">
    <p>Total - {{carttotoal}} $</p><input type="submit" value="checkout" (click)="payment()" class="cart_btn">
  </div>

  </div>
</div>


<!-- shopy Head -->
<div
  class="shopyheader"
  style="background-image: url(assets/image/Group-1893.jpg)"
>
  <div class="shopyheadings">
    <div class="head">
      <h3>ONLINE SHOP</h3>
    </div>
  </div>
</div>

<!-- Shope items -->
<div class="shop-details">
  <div class="container">
    <div class="row">
      
      <!-- <ng-template ngFor let-item [ngForOf]="data" >

      <div class="col-lg-4 col-md-6">
        <div class="shop-item-details">
          <div class="shopy-image">
            <img src="{{item.shop_image}}" />
          </div>
          <div class="item-name">
            <h2>{{item.shop_head}}</h2>
          </div>
          <div class="prd-location">
            <select class="form-select form-control " aria-label="">
              <option selected>SELECT LOCATION</option>
              <option value="{{item.shop_usPrice}}">USA ${{item.shop_usPrice}} USD</option>
              <option value="{{item.shop_canadaPrice}}">Canada & Mexico ${{item.shop_canadaPrice}} USD</option>
              <option value="{{item.shop_other}}">Rest of the World ${{item.shop_other}} USD</option>
            </select>
          </div>
          <div class="shopy-btns">
            <div class="row">
              <div class="col-6">
                <a href="onlineshopdetails/{{item.shop_id}}" class="btn-shop">
                  View Details
                </a>
              </div>
              <div class="col-6">
                <a href="/" class="btn-shop">
                  Buy Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-template> -->

      
     
    </div>

  <ng-template ngFor let-item [ngForOf]="data" >
<div class="sessions_elements">
  <div class="header_elements my-3">
    <h4>{{item.shopcata_head}}</h4>
   <div [innerHtml]=item.shopcata_details ></div>
  </div>
  <div class="row">
    
      <ng-template ngFor let-items [ngForOf]="item.dataset" >
      
      <div class="col-lg-4 col-md-6">
        <form #formshop="ngForm" (ngSubmit)="onClickSubmit(formshop.value)">
       
        <div class="shop-item-details">
          <a routerLink="/onlineshopdetails/{{items.shop_id}}" >
          <div class="shopy-image">
            <img src="{{items.shop_image}}" />
          </div>
          </a>
          <div class="item-name">
            <h2>{{items.shop_head}}</h2>
          </div>
          <input type="hidden" name="shophead" [ngModel]="items.shop_head" >
          <div class="prd-location">
            <div class="" *ngIf="getuserinfo; else elseBlock">
              <select class="form-select fullsize mb-3" aria-label="" [ngModel] name="shop_rate" >
                <option [ngValue]="null" [disabled]="true" [selected]='true'>MAKE A SELECTION</option>
              <option value="{{items.shopmember_usPrice}} USA">USA ${{items.shopmember_usPrice}} USD</option>
                    <option value="{{items.shopmember_canadaPrice}} Canada & Mexico">Canada & Mexico ${{items.shopmember_canadaPrice}} USD</option>
                    <option value="{{items.shopmember_other}} Rest of the World">Rest of the World ${{items.shopmember_other}} USD</option>
            </select>
            </div>
            <ng-template #elseBlock>
            <select class="form-select fullsize mb-3" aria-label="" [ngModel] name="shop_rate" >
              <option [ngValue]="null" [disabled]="true" [selected]='true'>MAKE A SELECTION</option>
                <option value="{{items.shop_usPrice}} USA">USA ${{items.shop_usPrice}} USD</option>
                <option value="{{items.shop_canadaPrice}} Canada & Mexico">Canada & Mexico ${{items.shop_canadaPrice}} USD</option>
                <option value="{{items.shop_other}} Rest of the World">Rest of the World ${{items.shop_other}} USD</option>
              </select>
            </ng-template>
          </div>
          <div class="shopy-btns">
            <div class="row">
              <div class="col-6">
                <input type="submit" class="btn-shop" value="Add to Cart">
                <!-- <a href="" class="btn-shop">
                To Cart
                </a> -->
              </div>
              <div class="col-6">
                <a (click)="getitems(formshop.value)" class="btn-shop">
                  Buy Now
                </a>
              </div>
            </div>
          </div>
          <p>  </p>
        </div>
         </form>
      </div>
      </ng-template>
    </div>
  
</div>
</ng-template>
      <!-- pagination -->
      <div class="event-pagination mt-2">
        <div class="container">
          <div class="pagination-items">
            <div class="elements">
              <a  [routerLink]="['/onlineshop/1']"  class="pag-btn">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
              </a>
              <ng-template [ngIf]="previous">
                <a  [routerLink]="['/onlineshop/',previous]"  class="pag-btn">
                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                </a>
              </ng-template>
             
              <span>
                <a  class="pag-item-previous"> PREVIOUS</a>
                <a  class="pag-item-next"> NEXT </a>
              </span>
              <ng-template [ngIf]="next">
              <a  [routerLink]="['/onlineshop/',next]" class="pag-btn">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </a>
            </ng-template>
              <a  [routerLink]="['/onlineshop/',last]"  class="pag-btn">
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

  </div>
</div>

<app-contactform></app-contactform>